import { Button } from '../Button';
import { Icon } from '../Icon';
import { useAppDispatch, useAppSelector } from 'app/store/store';
import { Modal } from '../Modal';
import styles from './DeleteNtfRuleModal.module.scss';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteNtfRuleMutation, useGetNtfRulesQuery } from 'app/api/facade';
import { setSelectedNtfRules } from 'app/utils/tableSlice';
import { useAlertHook } from 'app/hooks/useAlertHook';

interface DeleteNtfRuleModalProps {
  modalState: [boolean, Dispatch<SetStateAction<boolean>>];
}

export const DeleteNtfRuleModal = ({ modalState }: DeleteNtfRuleModalProps) => {
  const { t } = useTranslation();
  const { addAlert } = useAlertHook();
  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => state.userSlice.user);
  const selectedRules: string[] = useAppSelector((state) => state.tableSlice.fromTable?.ntfRulesArray);

  const [showDeleteModal, setShowDeleteModal] = modalState;
  const [deleteRule] = useDeleteNtfRuleMutation();
  const ntfRulesRequest = useGetNtfRulesQuery();

  const handleDeleteRule = (key: string) => {
    deleteRule(key)
      .unwrap()
      .then(() => {
        ntfRulesRequest.refetch();
        dispatch(setSelectedNtfRules([]));
      })
      .catch((error) => addAlert(error));
  };
  const handleDelete = () => {

    const user_id = user?.value.sub;

    if (user_id && selectedRules.length > 0) {
      selectedRules.forEach((rule) => {
        handleDeleteRule(rule);
        setShowDeleteModal(false);
      });
    }
  };
  return (
    <>
      <Modal
        component={
          <>
            <div className={styles.modal_subheader}>
              <Icon name="alert" size="28px" />
              {selectedRules.length === 1 || selectedRules.length === 0 ? (
                <span className={styles.alert_phrase}>{t('ModalDeleteNtfRuleQuestion')}</span>
              ) : (
                <span className={styles.alert_phrase}>{t('ModalDeleteNtfRulesQuestion', { length: selectedRules.length })}</span>
              )}
            </div>
            {selectedRules.length === 1 || selectedRules.length === 0 ? (
              <div className={styles.modal_question}>{t('RuleWillBeDeleted')}</div>
            ) : (
              <div className={styles.modal_question}>{t('RulesWillBeDeleted', { length: selectedRules.length })}</div>
            )}
            <div className={styles.buttons_group}>
              <Button variant="general" label={t('ButtonLabelDelete')} onClick={handleDelete} />
              <Button
                variant="general"
                label={t('ButtonLabelToDiscard')}
                type="reset"
                onClick={() => setShowDeleteModal(false)}
              />
            </div>
          </>
        }
        onClose={() => setShowDeleteModal(false)}
        headerTitle={t('ModalTitleDeleteNtfRule')}
        isShown={showDeleteModal}
      />
    </>
  );
};
